export const BETRIEB = "BETRIEB";
export const BETRIEB_STAMMDATEN_AENDERUNG = "BETRIEB_STAMMDATEN_AENDERUNG";
export const ANLAGE = "ANLAGE";
export const AENDERUNGSANTRAG_ANLAGE = "AENDERUNGSANTRAG_ANLAGE";
export const BESCHEID = "BESCHEID";
export const BESCHEID_MESSSTELLE = "BESCHEID_MESSSTELLE";
export const BERICHT = "BERICHT";
export const MESSSTELLE = "MESSSTELLE";
export const ENTLASTUNG = "ENTLASTUNG";
export const JAHRESBERICHT = "JAHRESBERICHT";
export const JAHRESBERICHT_PARAMETER_MESSWERTE = "JAHRESBERICHT_PARAMETER_MESSWERTE";
